import { useCustomMutation } from "@/shared/hooks/useCustomMutation";
import { useQueryClient } from "@tanstack/react-query";
import CategoryService from "@/features/categories/service/categoryService";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/shared/i18n";

export const useCategoryMutations = () => {
    const { t } = useTranslation('categories');
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const createCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.createCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            toast.success(t('categoryCreated'));
            navigate("/categories");
        },
        onError: (error) => {
            console.error(t('errorCreating'), error);
            toast.error(t('errorCreating'));
        },
    });

    const updateCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.updateCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            queryClient.invalidateQueries({ queryKey: ["get-category-by-id"] });
            toast.success(t('categoryUpdated'));
            navigate("/categories");
        },
        onError: (error) => {
            console.error(t('errorUpdating'), error);
            toast.error(t('errorUpdating'));
        },
    });

    const deleteCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.deleteCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            toast.success(t('categoryDeleted'));
        },
        onError: (error) => {
            console.error(t('errorDeleting'), error);
            toast.error(t('errorDeleting'));
        },
    });

    return {
        createCategory,
        updateCategory,
        deleteCategory,
    };
};